module.exports = __webpack_public_path__ + "staticcomp/img/cover.79306b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/1/cover.jpg
// module id = Mll0
// module chunks = 39